import React from 'react';
import { SvgProps } from '../Login';
import './Buildings.module.scss';

export default function Camper(props: SvgProps) {
    return (
        <>
            <svg
                styleName={`top camper ${props.selectedColor}`}
                id="Layer_2"
                data-name="Layer 2"
                xmlns="http://www.w3.org/2000/svg"
                width="226"
                height="155.69"
                viewBox="0 0 226 155.69"
            >
                <defs>
                    <style>{`.cls-1{fill:#2bcc74;}.cls-2{fill:#16d872;}.cls-3{fill:#ccc;}.cls-4{fill:#e6e6e6;}.cls-5{fill:#939393;}.cls-12,.cls-13,.cls-18,.cls-6{fill:#fff;}.cls-7{fill:#f44e4e;}.cls-16,.cls-8{fill:none;}.cls-8{stroke:#3a3a3a;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.59px;}.cls-9{isolation:isolate;}.cls-10{fill:#333;}.cls-11{fill:lime;}.cls-12{opacity:0.1;}.cls-13,.cls-15{opacity:0.8;}.cls-14{fill:#f5df61;}.cls-16{stroke:#b3b3b3;stroke-miterlimit:10;stroke-width:1.19px;}.cls-17{fill:#e2c49a;}.cls-18{opacity:0.7;}.cls-19{fill:#754c24;}.cls-20{opacity:0.2;}.cls-21{fill:#3db371;}`}</style>
                </defs>
                <polygon
                    className="cls-1"
                    points="162.94 57.13 75.78 107.29 125.54 135.83 212.69 85.67 162.94 57.13"
                />
                <polygon
                    className="cls-2"
                    points="75.78 107.29 75.78 111.39 125.54 139.93 125.54 135.83 75.78 107.29"
                />
                <polygon
                    className="cls-2"
                    points="212.69 85.67 212.69 89.76 125.54 139.93 125.54 135.83 212.69 85.67"
                />
                <polygon
                    className="cls-3"
                    points="71.84 81.7 45.48 96.88 60.53 105.51 86.89 90.34 71.84 81.7"
                />
                <polygon
                    className="cls-4"
                    points="45.48 96.88 45.48 98.12 60.53 106.75 60.53 105.51 45.48 96.88"
                />
                <polygon
                    className="cls-5"
                    points="86.89 90.34 86.89 91.58 60.53 106.75 60.53 105.51 86.89 90.34"
                />
                <polygon
                    className="cls-3"
                    points="63.44 70.37 46.16 80.32 56.03 85.97 73.31 76.03 63.44 70.37"
                />
                <polygon
                    className="cls-4"
                    points="46.16 80.32 46.16 81.13 56.03 86.78 56.03 85.97 46.16 80.32"
                />
                <polygon
                    className="cls-5"
                    points="73.31 76.03 73.31 76.84 56.03 86.78 56.03 85.97 73.31 76.03"
                />
                <polygon
                    className="cls-6"
                    points="188.63 26.61 193.9 28.57 191.82 29.7 192.66 31.84 187.48 30.51 188.63 26.61"
                />
                <polygon
                    className="cls-7"
                    points="187.48 30.51 192.66 31.84 191.82 29.7 188.08 28.48 187.48 30.51"
                />
                <polygon
                    className="cls-7"
                    points="188.08 28.48 190.14 29.16 191.02 27.5 191.02 27.5 188.63 26.61 188.08 28.48"
                />
                <polygon
                    className="cls-6"
                    points="190.14 29.16 188.08 28.48 187.48 30.51 189.97 31.15 190.14 29.16 190.14 29.16"
                />
                <path
                    className="cls-8"
                    d="M186.52,37.85a37.48,37.48,0,0,1,2.11-11.24"
                />
                <ellipse
                    cx="179.18"
                    cy="86.04"
                    rx="8.97"
                    ry="5.2"
                    transform="matrix(0.5, -0.86, 0.86, 0.5, 14.76, 197.73)"
                />
                <g className="cls-9">
                    <path
                        className="cls-10"
                        d="M180,78.32l.1,0,.28-.11.07,0,.35-.1L181,78l.1,0,.28,0,.43,0h.52l.28,0h.09L183,78h0l.29.1.08,0,.23.12a.2.2,0,0,1,.08,0h0l-4.47-2.54,0,0,0,0-.23-.11,0,0,0,0-.29-.1h0l-.32-.08h-.09a1.36,1.36,0,0,0-.29,0h-.06a2.28,2.28,0,0,0-.37,0h-.08l-.43,0h0l-.29.06-.09,0-.18,0h0l-.34.11-.07,0-.28.11h0l-.07,0-.3.14-.12.06-.4.22a6.76,6.76,0,0,0-.61.38l-.19.14-.4.3-.22.18-.36.32-.21.2-.14.12c-.11.12-.23.23-.34.36h0l-.34.38-.11.13-.25.3-.16.2-.12.17-.18.24-.12.17a2.9,2.9,0,0,0-.19.29l-.13.18-.05.08-.33.53,0,0-.06.11-.22.39-.09.18a1.14,1.14,0,0,1-.1.19.89.89,0,0,1-.08.17l-.21.45,0,.08v0c-.09.19-.16.38-.24.57l0,.11-.08.21-.1.28a2,2,0,0,0-.07.23,2.58,2.58,0,0,0-.08.26,1,1,0,0,0-.05.16c0,.1,0,.2-.07.29s-.06.22-.08.33l0,.11c0,.18-.07.36-.1.54s0,.07,0,.11a2,2,0,0,0,0,.24l0,.31a1.79,1.79,0,0,0,0,.23c0,.23,0,.47,0,.7,0,2,.71,3.42,1.85,4.08l4.48,2.54c-1.14-.66-1.85-2.08-1.86-4.08,0-.23,0-.47,0-.71a1.64,1.64,0,0,1,0-.22c0-.18,0-.37.07-.55s0-.08,0-.11c0-.22.08-.44.13-.65s0-.22.08-.33l.12-.45a2.76,2.76,0,0,0,.08-.27c.06-.16.11-.33.17-.5l.08-.21c.09-.24.18-.47.28-.7l0-.08c.09-.21.19-.41.29-.62l.09-.19.31-.57a.41.41,0,0,1,.07-.11c.12-.22.26-.44.4-.65l.12-.19.31-.45.18-.24c.09-.13.19-.25.29-.37l.25-.3c.14-.17.29-.35.45-.51h0l.48-.48.22-.2.36-.31.21-.18.4-.3.2-.14q.3-.21.6-.39a4,4,0,0,1,.41-.21l.11-.06Z"
                    />
                </g>
                <ellipse
                    cx="138.79"
                    cy="109.05"
                    rx="8.97"
                    ry="5.2"
                    transform="translate(-25.22 174.26) rotate(-59.84)"
                />
                <g className="cls-9">
                    <path
                        className="cls-10"
                        d="M139.6,101.32l.1,0,.28-.11.07,0,.35-.1.2-.05.09,0,.28-.06.43,0h.08a2.28,2.28,0,0,1,.37,0h.07l.28,0h.09l.32.08h0l.29.1.08,0,.23.11.08,0h0l-4.47-2.54,0,0,0,0-.23-.11-.05,0,0,0-.29-.1h0l-.32-.07h-.09a2.58,2.58,0,0,0-.29,0h-.06a2.28,2.28,0,0,0-.37,0h-.08a3.34,3.34,0,0,0-.43,0h0l-.29.05-.09,0-.18,0h0l-.34.11-.07,0-.28.11h0l-.07,0-.3.13-.12.06-.4.22-.61.38a1.33,1.33,0,0,1-.19.14l-.4.3-.22.18-.36.32-.21.2-.14.12-.34.36h0l-.34.38-.11.13-.25.31c-.05.06-.1.13-.16.19l-.12.17-.18.24-.12.17a2.9,2.9,0,0,0-.19.29l-.13.18a.35.35,0,0,1-.05.08q-.16.25-.33.54l0,0-.06.11-.22.39-.09.19-.1.19a1.19,1.19,0,0,1-.08.16l-.21.45,0,.08v0c-.09.19-.16.38-.24.58l0,.1-.08.21c0,.1-.07.19-.1.29a1.87,1.87,0,0,0-.07.22l-.08.26c0,.06,0,.11,0,.16s-.05.2-.07.3a3,3,0,0,0-.08.32l0,.11c0,.18-.07.36-.1.54s0,.07,0,.11a2,2,0,0,0,0,.24l0,.31a1.79,1.79,0,0,0,0,.23c0,.24,0,.47,0,.7,0,2,.71,3.42,1.85,4.08l4.48,2.54c-1.14-.66-1.85-2.07-1.86-4.08,0-.23,0-.47,0-.7,0-.08,0-.15,0-.23s0-.37.07-.55a.36.36,0,0,1,0-.11c0-.22.07-.43.12-.65s.05-.22.08-.33l.12-.45c0-.09.06-.18.08-.26s.11-.34.17-.51l.08-.21c.09-.24.18-.47.28-.7,0,0,0,0,0-.08.09-.21.19-.41.29-.62l.09-.19.31-.57.07-.11c.12-.22.26-.44.4-.65l.12-.19.31-.45.18-.24c.09-.13.19-.25.29-.37l.25-.3c.14-.17.29-.35.45-.51h0l.48-.47.22-.21.36-.31.21-.18.4-.3.2-.14q.3-.21.6-.39c.14-.07.27-.15.41-.21l.11-.06Z"
                    />
                </g>
                <path
                    styleName="cls-11 medium"
                    d="M187.79,41,127.42,76.08,100.81,59.41,94.87,82V97.61l30.88,17.78,9.79-5.63a5.49,5.49,0,0,0-.16,1.25c0,2.17,1.54,3,3.43,1.95a7.46,7.46,0,0,0,3.39-5.88,3.41,3.41,0,0,0-.15-1.07L176,86.46a6.13,6.13,0,0,0-.23,1.55c0,2.17,1.54,3,3.43,1.95a7.46,7.46,0,0,0,3.39-5.88,3.25,3.25,0,0,0-.23-1.28l7-4V63.19Z"
                />
                <path
                    className="cls-12"
                    d="M100.81,59.41,94.87,82v2.12l4.59,2.64a.32.32,0,0,0,.49-.28v-.69a.77.77,0,0,1,1.15-.67l16.45,9.47a1.7,1.7,0,0,1,.85,1.46V97a1.17,1.17,0,0,0,.59,1l6.76,3.89V99.79l1.67-23.71Z"
                />
                <path
                    className="cls-4"
                    d="M131.87,75.29l55.38-31.88a3.09,3.09,0,0,0,0-5.37L166.32,26a8.72,8.72,0,0,0-8.7,0l-56.4,31.2a3.11,3.11,0,0,0,0,5.38l22,12.72A8.72,8.72,0,0,0,131.87,75.29Z"
                />
                <path
                    className="cls-13"
                    d="M121.17,94.3,99.1,81.58A3.22,3.22,0,0,1,97.59,78l2.61-9.92a2.16,2.16,0,0,1,3.17-1.32l20.21,11.76a3.19,3.19,0,0,1,1.6,3l-.78,11.08A2.16,2.16,0,0,1,121.17,94.3Z"
                />
                <path
                    className="cls-6"
                    d="M119,98a1.17,1.17,0,0,1-.59-1v-.92a1.7,1.7,0,0,0-.85-1.46L101.1,85.14a.77.77,0,0,0-1.15.67v.69a.32.32,0,0,1-.49.28l-4.59-2.64V97.61l30.88,17.78V101.91Zm-20,.07a7,7,0,0,1-3.17-5.48c0-2,1.43-2.83,3.19-1.82a7,7,0,0,1,3.16,5.49C102.15,98.29,100.72,99.11,99,98.09Zm21.13,11.56a7,7,0,0,1-3.16-5.48c0-2,1.43-2.83,3.18-1.82a7,7,0,0,1,3.17,5.48C123.28,109.85,121.85,110.66,120.1,109.65Z"
                />
                <g className="cls-9">
                    <path
                        className="cls-14"
                        d="M119.64,103.51a5,5,0,0,1,2.27,3.93c0,1.44-1,2-2.28,1.29a5,5,0,0,1-2.27-3.92C117.37,103.37,118.39,102.78,119.64,103.51Z"
                    />
                </g>
                <g className="cls-9">
                    <path
                        className="cls-14"
                        d="M98.65,91.83a5,5,0,0,1,2.26,3.93c0,1.44-1,2-2.28,1.3a5,5,0,0,1-2.26-3.93C96.37,91.69,97.39,91.11,98.65,91.83Z"
                    />
                </g>
                <g className="cls-15">
                    <path
                        className="cls-6"
                        d="M185,54.46l.25,6.38a2,2,0,0,1-1,1.73l-14.36,8.36a2,2,0,0,1-3-1.73l-.25-6.38a2,2,0,0,1,1-1.73L182,52.73A2,2,0,0,1,185,54.46Z"
                    />
                </g>
                <g className="cls-15">
                    <path
                        className="cls-6"
                        d="M140.14,77.66v9.77a1.71,1.71,0,0,1-.86,1.48l-6.86,3.84a1.7,1.7,0,0,1-2.52-1.56l.44-9.9a1.69,1.69,0,0,1,.84-1.4l6.42-3.7A1.69,1.69,0,0,1,140.14,77.66Z"
                    />
                </g>
                <path
                    className="cls-16"
                    d="M149,61.15l36-20.91a2.83,2.83,0,0,0,0-4.91L166,24.33a8,8,0,0,0-7.95,0l-37,20.29a2.83,2.83,0,0,0,0,4.91l20,11.62A8,8,0,0,0,149,61.15Z"
                />
                <line
                    className="cls-16"
                    x1="145.16"
                    y1="62.21"
                    x2="145.16"
                    y2="65.11"
                />
                <line
                    className="cls-16"
                    x1="161.66"
                    y1="23.27"
                    x2="161.66"
                    y2="26.16"
                />
                <line
                    className="cls-16"
                    x1="186.5"
                    y1="37.85"
                    x2="186.5"
                    y2="40.74"
                />
                <line
                    className="cls-16"
                    x1="119.63"
                    y1="47.01"
                    x2="119.63"
                    y2="49.9"
                />
                <path className="cls-16" d="M132.23,38.28l28.16,16.33" />
                <path className="cls-16" d="M151.41,28.07l27.33,15.85" />
                <path
                    className="cls-17"
                    d="M142.7,51.23l29.53-17a1.22,1.22,0,0,0,0-2.12L164,27.37a3.41,3.41,0,0,0-3.44,0l-29.94,16.7a1.23,1.23,0,0,0,0,2.13l8.68,5A3.46,3.46,0,0,0,142.7,51.23Z"
                />
                <path
                    className="cls-18"
                    d="M189.35,70.59V65.31L144.56,91.09l4.27,1.54a1.56,1.56,0,0,0,1.3-.1Z"
                />
                <path
                    className="cls-18"
                    d="M148.59,95.25l-5-1.8a4.41,4.41,0,0,0-3.72.32l-14.15,8.14v13.48l63.6-36.61V73.5L150.78,95.07A2.63,2.63,0,0,1,148.59,95.25Z"
                />
                <polygon
                    className="cls-3"
                    points="32.49 77.33 18.81 85.2 32.49 93.08 46.16 85.2 32.49 77.33"
                />
                <polygon
                    className="cls-4"
                    points="18.81 85.2 18.81 86.74 32.49 94.61 32.49 93.08 18.81 85.2"
                />
                <polygon
                    className="cls-5"
                    points="46.16 85.2 46.16 86.74 32.49 94.61 32.49 93.08 46.16 85.2"
                />
                <path
                    className="cls-19"
                    d="M73.93,60.27l-1.16-16.2L67,44.48l1.15,16.2a1.38,1.38,0,0,0,.93,1.25,4.54,4.54,0,0,0,4.12-.29A1.37,1.37,0,0,0,73.93,60.27Z"
                />
                <path
                    className="cls-20"
                    d="M71.62,44.16l1.15,16.2A1.35,1.35,0,0,1,72,61.72a3.69,3.69,0,0,1-1.44.57,4.43,4.43,0,0,0,2.6-.65,1.37,1.37,0,0,0,.73-1.37l-1.16-16.2Z"
                />
                <path
                    className="cls-21"
                    d="M83.12,43.34l-.05-.14C83,42.63,66.73,0,66.73,0s-10,44.49-10.06,45.11l0,.11h0c0,2.08,1.45,4.08,4.3,5.47,5.39,2.62,13.78,2,18.72-1.33,2.6-1.78,3.71-4,3.4-6Z"
                />
                <path
                    className="cls-20"
                    d="M83.07,43.2C83,42.63,66.73,0,66.73,0s13.09,39.26,13.2,39.83L80,40h0c.31,2.05-.8,4.24-3.41,6-4.94,3.36-13.32,3.95-18.72,1.33-.29-.14-.56-.3-.82-.45a7.49,7.49,0,0,0,4,3.82c5.39,2.62,13.78,2,18.72-1.33,2.6-1.78,3.71-4,3.4-6h0Z"
                />
                <path
                    className="cls-19"
                    d="M51.76,66l-1-9.77-3.49.37,1,9.77a.85.85,0,0,0,.59.74,2.79,2.79,0,0,0,2.48-.26A.86.86,0,0,0,51.76,66Z"
                />
                <path
                    className="cls-20"
                    d="M50,56.26l1,9.78a.82.82,0,0,1-.41.84,2.36,2.36,0,0,1-.87.37,2.67,2.67,0,0,0,1.56-.44.86.86,0,0,0,.42-.85l-1-9.77Z"
                />
                <path
                    className="cls-21"
                    d="M57,55.53l0-.08c-.08-.34-10.78-25.79-10.78-25.79S41,56.77,41,57.15v.07h0c.05,1.26,1,2.45,2.71,3.22A12.48,12.48,0,0,0,55,59.24c1.54-1.12,2.17-2.47,1.94-3.71Z"
                />
                <path
                    className="cls-20"
                    d="M56.94,55.45c-.08-.34-10.78-25.79-10.78-25.79S54.89,53.13,55,53.48l0,.08h0c.23,1.24-.4,2.58-1.94,3.71a12.51,12.51,0,0,1-11.29,1.19c-.18-.08-.35-.17-.51-.26a4.53,4.53,0,0,0,2.48,2.23A12.48,12.48,0,0,0,55,59.24c1.54-1.12,2.17-2.47,1.94-3.71h0Z"
                />
            </svg>
        </>
    );
}
